// test1562
(1562 && 0);
